module.exports = __webpack_public_path__ + "assets/img/b1a9-gh.svg";